<template>
<div>
    <v-container> 
        <v-card class="ml-4" flat color="transparent">
            <v-card-text>
            <p class="red--text text-xs-center">
            App Still in development mode. Any one can use for free now.
            </p>
            </v-card-text>
        </v-card>
    </v-container>    
    <div class="ml-4" flat color="transparent">
            <v-layout>
                <v-flex xs2>
                    <v-btn round :color="bots ? 'primary' : ''" flat @click="showBots">Bots</v-btn>
                </v-flex>
                <!-- <v-flex xs2>
                    <v-btn round :color="templates ? 'primary' : ''" flat @click="showTemplates">Templates</v-btn>
                </v-flex>     -->
            </v-layout>
    </div>
    <bots v-if="bots"> </bots>
    <templates v-if="templates"> </templates>
</div>
</template>

<script>
import bots from './Display-bots.vue'
import templates from './Display-templates.vue'
import fb from '../plugins/fb.js'
export default {
    components:{
        bots,
        templates
    },data(){
        return{
            bots:true,
            templates:false
        }
    },
    methods:{
        showBots(){
            this.bots = true
            this.templates = false
        },
        showTemplates(){
            this.templates = true
            this.bots = false
        },
        getBotsList(){
            this.$store.dispatch('aFetchfbdata')
        }
    },
    created(){
        this.getBotsList()
    }
}
</script>
